import React from 'react';
import Modal from "react-bootstrap/Modal";
function UnSaveModel(props) {
    const {
        show,
        setShow,
        title = "Save Changes",
        message = "Do you want to save these changes?",
        cancelText = "Cancel",
        confirmText = "Save",
        onCancel,
        onConfirm,
        onExited,
        SuccessDoneClick,
        SaveProductMarkAdd,
    } = props;

    const handleCancel = onCancel || SuccessDoneClick || (() => setShow(false));
    const handleConfirm = onConfirm || SaveProductMarkAdd || (() => setShow(false));

    return (
        <Modal
            size='sm'
            show={show}
            centered
            className='unSaveModal'
            onHide={() => setShow(false)}
            onExited={onExited}
        >
            <Modal.Header className='align-items-center justify-content-between'>
                    <Modal.Title>{title}</Modal.Title>
                    <i onClick={handleCancel} className="fas fa-times"></i>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12">
                        <div className="confirm-msg mt-2">
                            <p>{message}</p>
                        </div>
                    </div> 
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="done-btns d-flex gap-2">
                            <button
                                type="button"
                                className="cancel-btn btn"
                                onClick={handleCancel}
                            >
                                {cancelText}
                            </button>
                             <button
                                type="button"
                                className="save-btn btn"
                                onClick={handleConfirm}
                            >
                                {confirmText}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default UnSaveModel
